// removed by extract-text-webpack-plugin
module.exports = {"Content":"_3aT78nmO1xXcb0yUat3Okt","Column":"_3xFyOlIRxMAPTE9a_1s-UK","Title":"_2_W_UGEdVDaxh_g0RR1MVB","Text":"_3hKZrsNLcRocM4DfIGU1lE","InputWrap":"_1B_VKMyOeLD4vVKvYyUU2g","DoubleCell":"_1lij8FWcJ8cp7gZWvtNr2","Input":"_1bJg4nMgebh4EMzJGs2YcC","Calendar":"_1FHAjgGIFAKgMjViJHzaAV","Label":"_2xmoDPXs9xNxpANnx_9uRd","container-fluid":"_3u_XwrLTLLMCCUv7mMsCmV"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Metal/ContractEdit/styles.module.css
// module id = 630
// module chunks = 0